import SelectField from 'shared/components/form/SelectField';
import TextField from 'shared/components/form/TextField';
import { botTypeOptions, CreateBotFormT } from 'shared/form-values/bots';

interface Props {
  isCreateMode?: boolean,
}

const BotForm = ({ isCreateMode }: Props) => {
  const fieldProps = {
    mb: '20px',
    w: {
      base: '100%',
      md: '50%',
    },
  };

  return (
    <>
      <SelectField<CreateBotFormT>
        name="type"
        options={botTypeOptions}
        label="Type"
        required
        placeholder="Enter type"
        {...fieldProps}
      />
      {isCreateMode && (
        <TextField<CreateBotFormT>
          name="token"
          label="Token"
          required
          placeholder="Enter token"
          {...fieldProps}
        />
      )}
      <TextField<CreateBotFormT>
        name="name"
        label="Name"
        placeholder="Enter name"
        {...fieldProps}
      />
    </>
  );
};

export default BotForm;
